// Data lives in blogPosts.json (not this file) so a plain Node build script
// can read it too, without needing to parse ES module syntax.
import blogPostsData from './blogPosts.json';

export const blogPosts = blogPostsData;

export function getBlogPostBySlug(slug) {
  return blogPosts.find((post) => post.slug === slug);
}

export function getSortedBlogPosts() {
  return [...blogPosts].sort((a, b) => (a.date < b.date ? 1 : -1));
}
